
const tweekEditorRoute = {
  path: "flag-tweekEditor-12345",
  lazy: async () => {
    const mod = await import("../../views/Flags/TweekEditor.tsx");
    const TweekEditor = mod.default;
    return { Component: TweekEditor };
  },
};

export default tweekEditorRoute;
